import { useSelector } from "react-redux"
import { Navigate } from 'react-router-dom';
import SplashScreen from "../SplashScreen"
const AuthRoute = ({ component: Component }) => {
    const isLoggedIn = useSelector(state => state.AuthReducer.isLoggedIn)

    return (
        <div> 
            {
                isLoggedIn === null
                    ?
                    <SplashScreen />
                    :
                    isLoggedIn
                        ?
                        <Navigate to="/" />
                        :
                        <Component />
            }
        </div>
    )
}

export default AuthRoute;
